import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";

export function parseCountryKey(key: string) {
  const lowerKey = key.toLowerCase();
  return lowerKey.charAt(0).toUpperCase() + lowerKey.slice(1);
}

export function splitLanguages(language: LabelLanguage) {
  switch (language) {
    case LabelLanguage.BilingualEnglishFrenchEnglishFirst:
    case LabelLanguage.BilingualEnglishFrenchFrenchFirst:
      return [LabelLanguage.English, LabelLanguage.French];

    case LabelLanguage.BilingualEnglishSpanishEnglishFirst:
    case LabelLanguage.BilingualEnglishSpanishSpanishFirst:
      return [LabelLanguage.English, LabelLanguage.Spanish];

    case LabelLanguage.English:
      return [LabelLanguage.English];

    case LabelLanguage.French:
      return [LabelLanguage.French];

    case LabelLanguage.Spanish:
      return [LabelLanguage.Spanish];

    default:
      return [];
  }
}